import script from "./SettingsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItem.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItem.vue?vue&type=style&index=0&id=f73e504a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f73e504a"]])

export default __exports__